import React from 'react';
import Img from 'gatsby-image';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { media } from '../../../utils/media-queries';

const Image = ({ imageSrc, alt }) => (
  <StyledImage className="grid">
    <figure>
      <Img fluid={imageSrc} alt={alt} />
    </figure>
  </StyledImage>
);

const StyledImage = styled.section`
  margin-bottom: var(--v-spacing-M);

  @media ${media.L} {
    figure {
      grid-column: 1 / 14;
    }
  }
`;

Image.propTypes = {
  imageSrc: PropTypes.object,
  alt: PropTypes.string,
};

export default Image;
